import { type FLAG, FLAGS, DEFAULT_STATES } from './flags';

const featureFlagStore = new Map<FLAG, boolean>(
  (Object.keys(FLAGS) as FLAG[]).map((flag) => {
    const storedValue = localStorage.getItem(`ff:${flag}`);
    if (storedValue === null) {
      return [flag, DEFAULT_STATES[flag] ?? false] as const;
    }

    return [flag, Boolean(+storedValue)] as const;
  })
);

export function isFeatureFlagEnabled(flag: FLAG): boolean {
  return featureFlagStore.get(flag) ?? false;
}

export function setFeatureFlag(flag: FLAG, value: boolean) {
  featureFlagStore.set(flag, value);
  if (value) {
    localStorage.setItem(`ff:${flag}`, '1');
  } else {
    localStorage.setItem(`ff:${flag}`, '0');
  }
  window.location.reload();
}
